import type { Bridge } from '../../contracts/bridge';

interface SidebarProps {
  bridges: Bridge[];
  selectedBridge: Bridge | null;
  onBridgeSelect: (bridge: Bridge) => void;
  isLoading: boolean;
}

export function Sidebar({
  bridges,
  selectedBridge,
  onBridgeSelect,
  isLoading,
}: SidebarProps) {
  return (
    <aside className="sidebar">
      <div className="p-4">
        <h2 className="text-sm font-semibold uppercase text-secondary mb-4">
          Bossier Parish Bridges
        </h2>
        <input
          type="text"
          className="input mb-4"
          placeholder="Search bridges..."
        />
      </div>
      <div className="bridge-list">
        {isLoading ? (
          <div className="p-4">
            <div className="skeleton skeleton--bridge" />
            <div className="skeleton skeleton--bridge" />
            <div className="skeleton skeleton--bridge" />
          </div>
        ) : bridges.length === 0 ? (
          <div className="p-4 text-secondary text-sm">
            No bridges found. Click sync to load bridges.
          </div>
        ) : (
          bridges.map((bridge) => (
            <BridgeListItem
              key={bridge.bridge_id}
              bridge={bridge}
              isSelected={selectedBridge?.bridge_id === bridge.bridge_id}
              onSelect={onBridgeSelect}
            />
          ))
        )}
      </div>
    </aside>
  );
}

interface BridgeListItemProps {
  bridge: Bridge;
  isSelected: boolean;
  onSelect: (bridge: Bridge) => void;
}

function BridgeListItem({ bridge, isSelected, onSelect }: BridgeListItemProps) {
  const className = `bridge-list-item ${isSelected ? 'bridge-list-item--selected' : ''}`;

  return (
    <div className={className} onClick={() => onSelect(bridge)}>
      <div className="font-medium truncate">{bridge.name}</div>
      <div className="text-xs text-secondary">
        {bridge.route || 'No route'} • {bridge.lat.toFixed(4)}, {bridge.lon.toFixed(4)}
      </div>
    </div>
  );
}
